import { selectAccountId } from 'affiny-core/redux/selectors/accountSelectors';
import { call, select } from 'redux-saga/effects';
import { ScoresResource } from '../../core/resources/scores.resource';
import { scoreSerializer } from '../../models/score/score.serializer';

export function* getScore(otherAccountId: string) {
  const myAccountId = yield select(selectAccountId);
  const response = yield call(
    ScoresResource.getScore,
    myAccountId,
    otherAccountId
  );

  return scoreSerializer(response);
}
